module.exports = __webpack_public_path__ + "assets/img/20_431.089b4420.jpg";